﻿interface GroupedData<T> {
    [key: string]: T[];
}

const group = <T, K extends keyof T>(array: T[], property: K): GroupedData<T> =>
    array.reduce((result: GroupedData<T>, object: T) => {
        const key = object[property] as string;

        if (!result[key]) {
            result[key] = [];
        }

        result[key].push(object);

        return result;
    }, {});

export default group;
